import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const FilterContext = createContext(null);

// Get initial state from localStorage
const getInitialFilterState = () => {
  try {
    const saved = localStorage.getItem('smcp_filters');
    if (saved) {
      const parsed = JSON.parse(saved);
      return {
        plant: parsed.plant || 'PLANT-A',
        area: parsed.area || 'all',
        timeRange: parsed.timeRange || '30days'
      };
    }
  } catch (e) {
    console.warn('Failed to load filters from localStorage:', e);
  }
  return {
    plant: 'PLANT-A',
    area: 'all',
    timeRange: '30days'
  };
};

export const FilterProvider = ({ children }) => {
  const initialState = getInitialFilterState();
  
  const [plant, setPlantState] = useState(initialState.plant);
  const [area, setAreaState] = useState(initialState.area);
  const [timeRange, setTimeRangeState] = useState(initialState.timeRange);

  // Persist to localStorage on change
  useEffect(() => {
    try {
      localStorage.setItem('smcp_filters', JSON.stringify({
        plant,
        area,
        timeRange
      }));
    } catch (e) {
      console.warn('Failed to save filters to localStorage:', e);
    }
  }, [plant, area, timeRange]);

  const setPlant = useCallback((newPlant) => {
    setPlantState(newPlant);
    // Reset area to 'all' when plant changes
    setAreaState('all');
  }, []);

  const setArea = useCallback((newArea) => {
    setAreaState(newArea);
  }, []);

  const setTimeRange = useCallback((range) => {
    setTimeRangeState(range);
  }, []);

  const value = {
    plant,
    area,
    timeRange,
    setPlant,
    setArea,
    setTimeRange
  };

  return (
    <FilterContext.Provider value={value}>
      {children}
    </FilterContext.Provider>
  );
};

export const useFilters = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error('useFilters must be used within a FilterProvider');
  }
  return context;
};

export default FilterContext;
